import { VzPageContainer } from "../../../layouts/VzPageContainer";
import {
  Modal,
  Col,
  Row,
  Overlay,
  Button,
  Popover,
  Container,
} from "react-bootstrap";
import { connect } from "react-redux";
import CustomDataTable from "../../../layouts/DataTables/CustomDataTable";
import {
  getGlobalSettings,
  addGlobalSetting,
  deleteGlobalSetting,
  updateGlobalSetting,
} from "./AppGlobalSettingActions";
import { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../../layouts/Input/FormikControl";
import { confirmAlert } from "react-confirm-alert";

const AppGlobalSetting = (props) => {
  const [isView, setIsView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [currentGlobalSetting, setCurrentGlobalSetting] = useState(null);

  const validationSchema = Yup.object().shape({
    variableName: Yup.string()
      .trim("No leading or trailing spaces allowed")
      .required("Variable Name is required"),
    variableValue: Yup.string().required("Variable Value is Required"),
  });
  const columns = [
    {
      Header: "Variable Name",
      accessor: "variableName",
    },
    {
      Header: "Variable Value",
      accessor: "variableValue",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div>
          <button onClick={() => View(original.id)} className="btn btn-sm">
            <i className="fas fa-eye"></i>
          </button>
          &nbsp;
          <button onClick={() => Edit(original.id)} className="btn btn-sm">
            <i className="fas fa-edit"></i>
          </button>
          {/* &nbsp;
          <button onClick={() => Delete(original.id)} className="btn btn-sm">
            <i className="fas fa-trash"></i>
          </button> */}
        </div>
      ),
    },
  ];

  const initialValues = {
    id: "",
    variableName: "",
    variableValue: "",
    description: "",
  };

  const handleSubmit = async (data) => {
    let newGlobalSetting = {
      variableName: data.variableName,
      variableValue: data.variableValue,
      description: data.description,
    };
    if (!isEdit) {
      await props.addGlobalSetting(newGlobalSetting);
    } else {
      await props.updateGlobalSetting(
        currentGlobalSetting.id,
        newGlobalSetting
      );
    }

    props.getGlobalSettings();
    setCurrentGlobalSetting({ ...initialValues });
    setModalShow(false);
  };

  const OpenModelForAddGlobalSetting = () => {
    setCurrentGlobalSetting(initialValues);
    setModalShow(true);
    setIsView(false);
    setIsEdit(false);
  };

  const View = (id) => {
    let tempObj = props.AppGlobalSetting.find((detail) => detail.id === id);
    if (tempObj == null) {
      return;
    }
    setCurrentGlobalSetting({ ...tempObj });
    setModalShow(true);
    setIsView(true);
    setIsEdit(false);
  };

  const Edit = (id) => {
    let tempObj = props.AppGlobalSetting.find((detail) => detail.id === id);
    if (tempObj == null) {
      return;
    }
    setCurrentGlobalSetting({ ...tempObj });
    setModalShow(true);
    setIsView(false);
    setIsEdit(true);
  };

  const Delete = (id) => {
    confirmAlert({
      closeOnEscape: true,
      closeOnClickOutside: true,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <Modal.Dialog>
              <Modal.Header id="customized-dialog-title">
                <Modal.Title>Confirm to Delete</Modal.Title>
                <button
                  type="button"
                  onClick={() => onClose()}
                  className="btn-close"
                  aria-label="No"
                ></button>
              </Modal.Header>
              <Modal.Body dividers>
                <p>Are you sure you want to delete this?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => {
                    DeleteRecord(id);
                    onClose();
                  }}
                  variant="outline-primary"
                >
                  Yes, Delete it!
                </Button>
                <Button
                  variant="primary"
                  onClick={onClose}
                  className="btn btn-primary"
                >
                  No
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </div>
        );
      },
    });
  };

  const DeleteRecord = async (id) => {
    await props.deleteGlobalSetting(id);
  };

  useEffect(() => {
    props.getGlobalSettings();
  }, []);

  return (
    <div>
      <VzPageContainer title="App Global Settings">
        <Row>
          <Col md={{ span: 3 }} style={{ float: "left" }}>
            <h4>
              <b>App Global Settings</b>
            </h4>
          </Col>
        </Row>

        {/* <Row>
          <Col xs={12} md={12}>
            <Button
              className="form-btn pull-right"
              variant="primary"
              style={{ float: "right" }}
              onClick={OpenModelForAddGlobalSetting}
            >
              <i className="fa fa-plus" /> Add New Global Setting
            </Button>
          </Col>
        </Row> */}
        <br></br>
        <Row>
          <Col xs={12} md={12}>
            <CustomDataTable
              data={props.AppGlobalSetting ?? []}
              columns={columns}
              getTrProps={() => null}
            />
          </Col>
        </Row>
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form autoComplete="off">
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                    App Global Setting
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Container>
                    <Row>
                      <Col xs={6} md={6}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            readOnly={isView || isEdit}
                            control="input"
                            type="variableName"
                            label="Variable Name"
                            name="variableName"
                            handleOnChange={(e) =>
                              (currentGlobalSetting.variableName = e)
                            }
                            value={currentGlobalSetting.variableName}
                          />
                        </div>
                      </Col>
                      <Col xs={6} md={6}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            readOnly={isView}
                            control="input"
                            type="variableValue"
                            label="Variable Value"
                            name="variableValue"
                            value={currentGlobalSetting.variableValue}
                            handleOnChange={(e) =>
                              (currentGlobalSetting.variableValue = e)
                            }
                          />
                        </div>
                      </Col>
                      <Col xs={12} md={12}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            readOnly={isView || isEdit}
                            control="input"
                            type="description"
                            label="Description"
                            name="description"
                            value={currentGlobalSetting.description}
                            handleOnChange={(e) =>
                              (currentGlobalSetting.description = e)
                            }
                          />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Modal.Body>
                <Modal.Footer>
                  {isView ? null : (
                    <>
                      <input
                        type="submit"
                        className="btn btn-primary"
                        value="Save"
                      />
                      <Button
                        className="btn btn-default"
                        onClick={() => setModalShow(false)}
                      >
                        Close
                      </Button>
                    </>
                  )}
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    AppGlobalSetting: state.AppGlobalSetting,
  };
};

export default connect(mapStateToProps, {
  getGlobalSettings,
  addGlobalSetting,
  deleteGlobalSetting,
  updateGlobalSetting,
})(AppGlobalSetting);
